<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 14.5V1.5H9.59675L12.5 14.5H3.5Z" fill="transparent" stroke="currentColor"/>
<circle cx="3.49994" cy="1.5" r="1.06879" fill="currentColor"/>
<circle cx="3.49994" cy="14.5" r="1.06879" fill="currentColor"/>
<circle cx="12.4999" cy="14.5" r="1.06879" fill="currentColor"/>
<circle cx="9.70306" cy="1.5" r="1.06879" fill="currentColor"/>
</svg>
